import React from 'react';

export default function NotLoading({ loading = true, placeholder = 'Buscando dados...', children }) {
  if (Boolean(loading)) {
    return placeholder;
  }

  return <>{children}</>;
}
